<template>
  <article id="project-loader">
    <div class="cards-container">
      <SportCard
        v-for="(sport, i) in sportCards"
        :key="i + '-sportcard'"
        :sport="sport"
        :forceShow="true"
        :isPreSelected="i === selectedSportIndex"
      />
    </div>

    <Loader />
    <div class="text-container">
      <p class="text">Your changes are taking place</p>

      <p class="text">It might take a few seconds.</p>
    </div>
  </article>
</template>

<script>
import CONSTANTS from "@/constants.js";
import Loader from "@/components/Utils/Loader";
import SportCard from "@/components/Projects/Project/Sidebar/SportCard";
import { mapGetters, mapState } from "vuex";
export default {
  name: "ProjectLoader",
  components: { Loader, SportCard },
  data() {
    return {
      selectedSportIndex: 0,
      intervalId: 0,
    };
  },
  computed: {
    ...mapState("snapsheet", ["collectionsCardsData"]),
    ...mapGetters("project", ["isPlaybook"]),
    sportCards() {
      return this.isPlaybook
        ? [...CONSTANTS.FSG_PLAYBOOK_SPORTS_CARDS].slice(0, 5)
        : [...this.collectionsCardsData].slice(0, 5);
    },
  },

  methods: {
    loopForSelectAnSport() {
      return setInterval(() => {
        this.selectedSportIndex === this.sportCards.length - 1
          ? (this.selectedSportIndex = 0)
          : this.selectedSportIndex++;
      }, 400);
    },
  },

  mounted() {
    this.intervalId = this.loopForSelectAnSport();
  },

  destroyed() {
    clearInterval(this.intervalId);
  },
};
</script>

<style lang="scss" >
#project-loader {
  .cards-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 3rem;
    margin-bottom: 4rem;

    .sport-card {
      width: 100px !important;
      height: 100px !important;

      .sport-card-icon {
        width: 50px;
        height: 50px;
      }
    }
  }
  .text-container {
    margin-top: 2rem;
    .text {
      color: $grey-dark;
      text-align: center;
    }
  }
}
.kt-spinner:before {
  width: 30px;
  height: 30px;
  left: -15px;
}
.kt-spinner.kt-spinner--info:before {
  border: 3px solid #50ba73;
  border-right: 6px solid $grey-lightest;
}
</style>